import type { CacheStrategy } from '../types/index.d.ts';

class CacheManager {
    private strategy: CacheStrategy;
    private stats = { hits: 0, misses: 0, expirations: 0 };

    constructor(strategy: CacheStrategy) {
        this.strategy = strategy;
    }

    public async set(
        key: string,
        value: string,
        cache: boolean = true,
        ttl: number = 3600,
    ): Promise<void> {
        await this.strategy.set(key, value, cache, ttl);
    }

    public async get(key: string): Promise<string | null> {
        const value = await this.strategy.get(key);

        if (value) {
            this.stats.hits++;
        } else {
            this.stats.misses++;
        }

        return value;
    }

    public async delete(key: string): Promise<void> {
        await this.strategy.delete(key);
    }

    public getStats() {
        return this.stats;
    }
}

export default CacheManager;
